module.exports = __webpack_public_path__ + "documents/VZPH_Fios_Terms_and_Conditions.pdf";


//////////////////
// WEBPACK FOOTER
// ./packages/smart-home-support/pages/termspage/pdf/VZPH_Fios_Terms_and_Conditions.pdf
// module id = 3530
// module chunks = 0